import api from '../token';

export const AlterarUnidade = async (dados) => {
  try {
    const response = await api.post('/alterUnidade', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};




